export default "__VITE_ASSET__rlW0OzM$__"